/** ----------------------------------------
     State
 ---------------------------------------- */

const state = () => {
    return {
        list: {
            community: {},
            companies: {},
        },
        current: null,
    }
};

/** ----------------------------------------
    Export State
 ---------------------------------------- */

export default state;